module.exports = [
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 16221.57
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 16147.03
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 15002.03
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 13939.97
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 13929.1
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 13217.17
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 13460.95
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 15503.87
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 15256.17
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 14523.33
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 13975.6
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 13706.1
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 13491.3
  },
  {
    "AgeGroup": "85+ years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 13512.15
  }
]
